<app-mb-card class="info-card">
  <header>
    <h3>Añadir información para una nueva compañía</h3>
  </header>
  <footer [formGroup]="newCompanyForm">
    <p>Datos básicos</p>
    <div>
      <app-mb-field [title]="'Nombre comercial *'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE Group" formControlName="companyComercialName"
          autocomplete="new-text">
        @if (hasError('companyComercialName')) {
          <h6 translate>
            {{ hasError('companyComercialName') === 'required' ? 'required' : hasError('companyComercialName')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'CIF *'" fullwidth>
        <input type="text" placeholder="Ej.: B13456781" formControlName="companyCif"
          autocomplete="new-password">
        @if (hasError('companyCif')) {
          <h6 translate>
          {{ hasError('companyCif') === 'required' ? 'required' : hasError('companyCif')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Nombre fiscal *'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE SA" formControlName="companyFiscalName"
          autocomplete="new-password">
        @if (hasError('companyFiscalName')) {
          <h6 translate>
          {{ hasError('companyFiscalName') === 'required' ? 'required' : hasError('companyFiscalName')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Active'" inline>
        <input type="checkbox" formControlName="active" autocomplete="new-password">
      </app-mb-field>
    </div>
    <p>Datos de localización</p>
    <div>
      <app-mb-field [title]="'Dirección'" fullwidth>
        <input type="text" placeholder="Ej.: Calle john doe 5" formControlName="companyAddress"
          autocomplete="new-text">
        @if (hasError('companyAddress')) {
          <h6 translate>
            {{ hasError('companyAddress') === 'required' ? 'required' : hasError('companyAddress')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Ciudad'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="companyCity" autocomplete="new-password">
        @if (hasError('companyCity')) {
          <h6 translate>
          {{ hasError('companyCity') === 'required' ? 'required' : hasError('companyCity')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Código postal'" fullwidth>
        <input type="text" placeholder="Ej.: 28000" formControlName="companyPostalCode"
          autocomplete="new-password">
        @if (hasError('companyPostalCode')) {
          <h6 translate>
          {{ hasError('companyPostalCode') === 'required' ? 'required' : hasError('companyPostalCode')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Provincia'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="companyProvince" autocomplete="new-text">
        @if (hasError('companyProvince')) {
          <h6 translate>
            {{ hasError('companyProvince') === 'required' ? 'required' : hasError('companyProvince')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Región'" fullwidth>
        <input type="text" placeholder="Ej.: Comunidad de Madrid" formControlName="companyRegion"
          autocomplete="new-password">
        @if (hasError('companyRegion')) {
          <h6 translate>
          {{ hasError('companyRegion') === 'required' ? 'required' : hasError('companyRegion')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'País *'" fullwidth>
        <select formControlName="companyCountry">
          <option [ngValue]="null">Elige un país</option>
          @for (country of countries; track country) {
            <option [ngValue]="country">{{ country }}</option>
          }
        </select>
        @if (hasError('companyCountry')) {
          <h6 translate>
          {{ hasError('companyCountry') === 'required' ? 'required' : hasError('companyCountry')}}</h6>
        }
      </app-mb-field>
    </div>
    <p>Datos de contacto</p>
    <div>
      <app-mb-field [title]="'Fax'" fullwidth>
        <input type="number" placeholder="Ej.: 999 12 34 56" formControlName="companyFax" autocomplete="new-text">
        @if (hasError('companyFax')) {
          <h6 translate>
          {{ hasError('companyFax') === 'required' ? 'required' : hasError('companyFax')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Teléfono'" fullwidth>
        <input type="number" placeholder="Ej.: 666 56 78 90 " formControlName="companyPhone"
          autocomplete="new-text">
        @if (hasError('companyPhone')) {
          <h6 translate>
          {{ hasError('companyPhone') === 'required' ? 'required' : hasError('companyPhone')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Web'" fullwidth>
        <input type="text" placeholder="Ej.: www.johndoe.com" formControlName="companyWeb"
          autocomplete="new-password">
        @if (hasError('companyWeb')) {
          <h6 translate>
          {{ hasError('companyWeb') === 'required' ? 'required' : hasError('companyWeb')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Email'" fullwidth>
        <input type="email" placeholder="Ej.: johndoe@example.com" formControlName="companyEmail"
          autocomplete="new-password">
        @if (hasError('companyEmail')) {
          <h6 translate>
          {{ hasError('companyEmail') === 'required' ? 'required' : hasError('companyEmail')}}</h6>
        }
      </app-mb-field>
    </div>
    <p>Datos de usuario administrador</p>
    <div>
      <app-mb-field [title]="'Email *'" fullwidth>
        <input type="email" placeholder="Ej.: johndoe@example.com" formControlName="userEmail" autocomplete="new-text">
        @if (hasError('userEmail')) {
          <h6 translate>
          {{ hasError('userEmail') === 'required' ? 'required' : hasError('userEmail')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Password *'" fullwidth>
        <input type="text" placeholder="Ej.: password " formControlName="userPassword"
          autocomplete="new-text">
        @if (hasError('userPassword')) {
          <h6 translate>
          {{ hasError('userPassword') === 'required' ? 'required' : hasError('userPassword')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Firstname *'" fullwidth>
        <input type="text" placeholder="Ej.: John" formControlName="userFirstname"
          autocomplete="new-password">
        @if (hasError('userFirstname')) {
          <h6 translate>
          {{ hasError('userFirstname') === 'required' ? 'required' : hasError('userFirstname')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Lastname *'" fullwidth>
        <input type="text" placeholder="Ej.: DOE" formControlName="userLastname"
          autocomplete="new-password">
        @if (hasError('userLastname')) {
          <h6 translate>
          {{ hasError('userLastname') === 'required' ? 'required' : hasError('userLastname')}}</h6>
        }
      </app-mb-field>

    </div>
    <p>Productos habilitados para la compañía</p>
    @if (showProductsForm) {
      <div [formGroup]="productsForm">
        @for (product of products; track product) {
          <app-mb-field [title]="product.mproductName" inline>
            <input type="checkbox" [formControlName]="product.mproductCode">
          </app-mb-field>
        }
      </div>
    }
    <p>Aplicaciones habilitadas para la compañía</p>
    @if (showApplicationsForm) {
      <div [formGroup]="applicationsForm">
        @if (!((applications | filterApplicationsByProducts: getActiveProducts()).length > 0)) {
          <span>No hay aplicaciones disponibles para los productos que has habilitado</span>
        }
        @for (application of applications | filterApplicationsByProducts: getActiveProducts(); track application) {
          <app-mb-field [title]="application.applicationName" inline>
            <input type="checkbox" [formControlName]="application.applicationName">
          </app-mb-field>
        }
      </div>
    }
    <p>Editar imagen de la compañía</p>
    <div>
      <input #companyUploadInput type="file" style="margin: 2rem 1rem" (change)="companyUploadInputChanged($event)">
    </div>
    <p>Datos de primer centro de la compañía</p>
    <div>
      <app-mb-field [title]="'Nombre comercial *'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE Center" formControlName="centerComercialName" autocomplete="new-text">
        @if (hasError('centerComercialName')) {
          <h6 translate>
          {{ hasError('centerComercialName') === 'required' ? 'required' : hasError('centerComercialName')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Código'" fullwidth>
        <input type="text" placeholder="Ej.: JDCENTERCODEXXX" formControlName="centerCode" autocomplete="new-text">
        @if (hasError('centerCode')) {
          <h6 translate>
          {{ hasError('centerCode') === 'required' ? 'required' : hasError('centerCode')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'CIF'" fullwidth>
        <input type="text" placeholder="Ej.: B13423741" formControlName="centerCif" autocomplete="new-text">
        @if (hasError('centerCif')) {
          <h6 translate>
          {{ hasError('centerCif') === 'required' ? 'required' : hasError('centerCif')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Nombre fiscal'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE Center SL" formControlName="centerFiscalName" autocomplete="new-text">
        @if (hasError('centerFiscalName')) {
          <h6 translate>
          {{ hasError('centerFiscalName') === 'required' ? 'required' : hasError('centerFiscalName')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Dirección fiscal'" fullwidth>
        <input type="text" placeholder="Ej.: Calle john doe 5" formControlName="centerFiscalAddress" autocomplete="new-text">
        @if (hasError('centerFiscalAddress')) {
          <h6 translate>
          {{ hasError('centerFiscalAddress') === 'required' ? 'required' : hasError('centerFiscalAddress')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Dirección *'" fullwidth>
        <input type="text" placeholder="Ej.: Calle john doe 5" formControlName="centerAddress" autocomplete="new-text" (focusout)="onAddressChange($event)">
        @if (hasError('centerAddress')) {
          <h6 translate>
          {{ hasError('centerAddress') === 'required' ? 'required' : hasError('centerAddress')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Ciudad *'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="centerCity" autocomplete="new-text" (focusout)="onAddressChange($event)">
        @if (hasError('centerCity')) {
          <h6 translate>
          {{ hasError('centerCity') === 'required' ? 'required' : hasError('centerCity')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Código postal *'" fullwidth>
        <input type="text" placeholder="Ej.: 28000" formControlName="centerPostalCode" autocomplete="new-text" (focusout)="onAddressChange($event)">
        @if (hasError('centerPostalCode')) {
          <h6 translate>
          {{ hasError('centerPostalCode') === 'required' ? 'required' : hasError('centerPostalCode')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Provincia *'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="centerProvince" autocomplete="new-text" (focusout)="onAddressChange($event)">
        @if (hasError('centerProvince')) {
          <h6 translate>
          {{ hasError('centerProvince') === 'required' ? 'required' : hasError('centerProvince')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Región *'" fullwidth>
        <input type="text" placeholder="Ej.: Comunidad de Madrid" formControlName="centerRegion" autocomplete="new-text" (focusout)="onAddressChange($event)">
        @if (hasError('centerRegion')) {
          <h6 translate>
          {{ hasError('centerRegion') === 'required' ? 'required' : hasError('centerRegion')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'País *'" fullwidth >
        <select formControlName="centerCountry" (focusout)="onAddressChange($event)">
          <option [ngValue]="null">Elige un país</option>
          @for (country of countries; track country) {
            <option [ngValue]="country">{{ country }}</option>
          }
        </select>
        @if (hasError('centerCountry')) {
          <h6 translate>
          {{ hasError('centerCountry') === 'required' ? 'required' : hasError('centerCountry')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Tipo de centro *'" fullwidth>
        <select formControlName="centerType">
          <option [ngValue]="null">Elige un tipo de centro</option>
          @for (centerType of centerTypes; track centerType) {
            <option [ngValue]="centerType">{{ centerType.centerTypeName }}</option>
          }
        </select>
        @if (hasError('centerType')) {
          <h6 translate>
          {{ hasError('centerType') === 'required' ? 'required' : hasError('centerType')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Zona horaria *'" fullwidth>
        <select formControlName="centerTimezone" [compareWith]="setPreselected2">
          <option [ngValue]="null">Elige una zona horaria</option>
          @for (timezone of timezones; track timezone) {
            <option [ngValue]="timezone">{{ timezone }}</option>
          }
        </select>
        @if (hasError('centerTimezone')) {
          <h6 translate>
          {{ hasError('centerTimezone') === 'required' ? 'required' : hasError('centerTimezone')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Latitud GPS *'" fullwidth>
        <input type="number" placeholder="Ej.: 40.40564502" formControlName="centerLatitude" autocomplete="new-text" (focusout)="onGPSChange($event)">
        @if (hasError('centerLatitude')) {
          <h6 translate>
          {{ hasError('centerLatitude') === 'required' ? 'required' : hasError('centerLatitude')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Longitud GPS *'" fullwidth>
        <input type="number" placeholder="Ej.: -3.69344994" formControlName="centerLongitude" autocomplete="new-text" (focusout)="onGPSChange($event)">
        @if (hasError('centerLongitude')) {
          <h6 translate>
          {{ hasError('centerLongitude') === 'required' ? 'required' : hasError('centerLongitude')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Activo'" inline>
        <input type="checkbox" formControlName="centerActive" autocomplete="new-password">
      </app-mb-field>
      <app-mb-field [title]="'Visible'" inline>
        <input type="checkbox" formControlName="centerVisible" autocomplete="new-password">
      </app-mb-field>
    </div>
    @if (showMap) {
      <figure>
        <div #map></div>
      </figure>
    }
    <p>Datos de contacto de primer centro de la compañía</p>
    <div>
      <app-mb-field [title]="'Fax'" fullwidth>
        <input type="number" placeholder="Ej.: 999 12 34 56" formControlName="centerUserFax" autocomplete="new-text">
        @if (hasError('centerUserFax')) {
          <h6 translate>
          {{ hasError('centerUserFax') === 'required' ? 'required' : hasError('centerUserFax')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Teléfono *'" fullwidth>
        <input type="number" placeholder="Ej.: 666 78 89 00" formControlName="centerUserPhone" autocomplete="new-text">
        @if (hasError('centerUserPhone')) {
          <h6 translate>
          {{ hasError('centerUserPhone') === 'required' ? 'required' : hasError('centerUserPhone')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Email *'" fullwidth>
        <input type="email" placeholder="Ej.: johndoe@example.com" formControlName="centerUserMail" autocomplete="new-text">
        @if (hasError('centerUserMail')) {
          <h6 translate>
          {{ hasError('centerUserMail') === 'required' ? 'required' : hasError('centerUserMail')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Persona de contacto *'" fullwidth>
        <input type="email" placeholder="Ej.: John DOE" formControlName="centerUserContact" autocomplete="new-text">
        @if (hasError('centerUserContact')) {
          <h6 translate>
          {{ hasError('centerUserContact') === 'required' ? 'required' : hasError('centerUserContact')}}</h6>
        }
      </app-mb-field>
    </div>
    <p>Editar imagen del centro</p>
    <div>
      <input #centerUploadInput type="file" style="margin: 2rem 1rem" (change)="centerUploadInputChanged($event)">
    </div>
    @if (logCreatingCompany && (logCreatingCompany.length > 0) && logCreatingProducts && (logCreatingProducts.length > 0) && logCreatingApplications && (logCreatingApplications.length > 0)) {
      <ul>
        @for (log of logCreatingCompany; track log) {
          <li>{{ log }}</li>
        }
        @for (log of logCreatingProducts; track log) {
          <li>{{ log }}</li>
        }
        @for (log of logCreatingApplications; track log) {
          <li>{{ log }}</li>
        }
      </ul>
    }
    @if (userCreationFormErrorMessage) {
      <h6>{{ userCreationFormErrorMessage }}</h6>
    }
    <div>
      @if (!loading && !createdCompany) {
        <app-mb-button (click)="addNewCompany()">Crear</app-mb-button>
      }
      @if (createdCompany) {
        <app-mb-button [routerLink]="['/companies']">volver al listado</app-mb-button>
      }
      @if (createdCompany) {
        <app-mb-button [routerLink]="['/company', createdCompany?.internalId]">Ver compañía creada</app-mb-button>
      }
    </div>
  </footer>
</app-mb-card>
